/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net Command API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  ListModelHardpointLoadoutsParams,
  ModelHardpointLoadout,
  ModelHardpointLoadoutInput,
  ModelHardpointLoadouts,
  SchemaValidationErrorResponse,
  StandardError,
  ValidationError
} from '../../models';

import { axiosClient } from '../../../axiosAdminClient.ts';
import type { ErrorType } from '../../../axiosAdminClient.ts';




/**
 * @summary Create Model Hardpoint Loadout
 */
export const createModelHardpointLoadout = (
    modelHardpointLoadoutInput: MaybeRefOrGetter<ModelHardpointLoadoutInput>,
 signal?: AbortSignal
) => {
      modelHardpointLoadoutInput = toValue(modelHardpointLoadoutInput);

      return axiosClient<ModelHardpointLoadout>(
      {url: `/model-hardpoint-loadouts`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: modelHardpointLoadoutInput, signal
    },
      );
    }




export const getCreateModelHardpointLoadoutMutationOptions = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createModelHardpointLoadout>>, TError,CreateModelHardpointLoadoutMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createModelHardpointLoadout>>, TError,CreateModelHardpointLoadoutMutationVariables, TContext> => {

const mutationKey = ['createModelHardpointLoadout'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createModelHardpointLoadout>>, CreateModelHardpointLoadoutMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createModelHardpointLoadout(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateModelHardpointLoadoutMutationResult = NonNullable<Awaited<ReturnType<typeof createModelHardpointLoadout>>>
    export type CreateModelHardpointLoadoutMutationBody = ModelHardpointLoadoutInput
    export type CreateModelHardpointLoadoutMutationError = ErrorType<ValidationError | StandardError>
    export type CreateModelHardpointLoadoutMutationVariables = {data: ModelHardpointLoadoutInput}

    /**
 * @summary Create Model Hardpoint Loadout
 */
export const useCreateModelHardpointLoadout = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createModelHardpointLoadout>>, TError,CreateModelHardpointLoadoutMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createModelHardpointLoadout>>,
        TError,
        CreateModelHardpointLoadoutMutationVariables,
        TContext
      > => {
      return useMutation(getCreateModelHardpointLoadoutMutationOptions(options), queryClient);
    }
    /**
 * @summary Model Hardpoint Loadouts list
 */
export const listModelHardpointLoadouts = (
    params?: MaybeRefOrGetter<ListModelHardpointLoadoutsParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<ModelHardpointLoadouts>(
      {url: `/model-hardpoint-loadouts`, method: 'GET',
        params, signal
    },
      );
    }




export const getListModelHardpointLoadoutsQueryKey = (params?: MaybeRefOrGetter<ListModelHardpointLoadoutsParams>,) => {
    return [
    'model-hardpoint-loadouts', ...(params ? [params] : [])
    ] as const;
    }


export const getListModelHardpointLoadoutsQueryOptions = <TData = Awaited<ReturnType<typeof listModelHardpointLoadouts>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(params?: MaybeRefOrGetter<ListModelHardpointLoadoutsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listModelHardpointLoadouts>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListModelHardpointLoadoutsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listModelHardpointLoadouts>>> = ({ signal }) => listModelHardpointLoadouts(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listModelHardpointLoadouts>>, TError, TData>
}

export type ListModelHardpointLoadoutsQueryResult = NonNullable<Awaited<ReturnType<typeof listModelHardpointLoadouts>>>
export type ListModelHardpointLoadoutsQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Model Hardpoint Loadouts list
 */

export function useListModelHardpointLoadouts<TData = Awaited<ReturnType<typeof listModelHardpointLoadouts>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 params?: MaybeRefOrGetter<ListModelHardpointLoadoutsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listModelHardpointLoadouts>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListModelHardpointLoadoutsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Destroy Model Hardpoint Loadout
 */
export const destroyModelHardpointLoadout = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<void>(
      {url: `/model-hardpoint-loadouts/${id}`, method: 'DELETE', signal
    },
      );
    }




export const getDestroyModelHardpointLoadoutMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyModelHardpointLoadout>>, TError,DestroyModelHardpointLoadoutMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof destroyModelHardpointLoadout>>, TError,DestroyModelHardpointLoadoutMutationVariables, TContext> => {

const mutationKey = ['destroyModelHardpointLoadout'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof destroyModelHardpointLoadout>>, DestroyModelHardpointLoadoutMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  destroyModelHardpointLoadout(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DestroyModelHardpointLoadoutMutationResult = NonNullable<Awaited<ReturnType<typeof destroyModelHardpointLoadout>>>

    export type DestroyModelHardpointLoadoutMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type DestroyModelHardpointLoadoutMutationVariables = {id: string}

    /**
 * @summary Destroy Model Hardpoint Loadout
 */
export const useDestroyModelHardpointLoadout = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyModelHardpointLoadout>>, TError,DestroyModelHardpointLoadoutMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof destroyModelHardpointLoadout>>,
        TError,
        DestroyModelHardpointLoadoutMutationVariables,
        TContext
      > => {
      return useMutation(getDestroyModelHardpointLoadoutMutationOptions(options), queryClient);
    }
    /**
 * @summary Get Model Hardpoint Loadout
 */
export const modelHardpointLoadout = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<ModelHardpointLoadout>(
      {url: `/model-hardpoint-loadouts/${id}`, method: 'GET', signal
    },
      );
    }




export const getModelHardpointLoadoutQueryKey = (id: MaybeRefOrGetter<string>,) => {
    return [
    'model-hardpoint-loadouts',id
    ] as const;
    }


export const getModelHardpointLoadoutQueryOptions = <TData = Awaited<ReturnType<typeof modelHardpointLoadout>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof modelHardpointLoadout>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getModelHardpointLoadoutQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof modelHardpointLoadout>>> = ({ signal }) => modelHardpointLoadout(id, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof modelHardpointLoadout>>, TError, TData>
}

export type ModelHardpointLoadoutQueryResult = NonNullable<Awaited<ReturnType<typeof modelHardpointLoadout>>>
export type ModelHardpointLoadoutQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Get Model Hardpoint Loadout
 */

export function useModelHardpointLoadout<TData = Awaited<ReturnType<typeof modelHardpointLoadout>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof modelHardpointLoadout>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getModelHardpointLoadoutQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Update Model Hardpoint Loadout
 */
export const updateModelHardpointLoadout = (
    id: MaybeRefOrGetter<string>,
    modelHardpointLoadoutInput: MaybeRefOrGetter<ModelHardpointLoadoutInput>,
 signal?: AbortSignal
) => {
      id = toValue(id);
modelHardpointLoadoutInput = toValue(modelHardpointLoadoutInput);

      return axiosClient<ModelHardpointLoadout>(
      {url: `/model-hardpoint-loadouts/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: modelHardpointLoadoutInput, signal
    },
      );
    }




export const getUpdateModelHardpointLoadoutMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateModelHardpointLoadout>>, TError,UpdateModelHardpointLoadoutMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateModelHardpointLoadout>>, TError,UpdateModelHardpointLoadoutMutationVariables, TContext> => {

const mutationKey = ['updateModelHardpointLoadout'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateModelHardpointLoadout>>, UpdateModelHardpointLoadoutMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  updateModelHardpointLoadout(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateModelHardpointLoadoutMutationResult = NonNullable<Awaited<ReturnType<typeof updateModelHardpointLoadout>>>
    export type UpdateModelHardpointLoadoutMutationBody = ModelHardpointLoadoutInput
    export type UpdateModelHardpointLoadoutMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type UpdateModelHardpointLoadoutMutationVariables = {id: string;data: ModelHardpointLoadoutInput}

    /**
 * @summary Update Model Hardpoint Loadout
 */
export const useUpdateModelHardpointLoadout = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateModelHardpointLoadout>>, TError,UpdateModelHardpointLoadoutMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateModelHardpointLoadout>>,
        TError,
        UpdateModelHardpointLoadoutMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateModelHardpointLoadoutMutationOptions(options), queryClient);
    }
